import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Hidden } from '@material-ui/core'
import Button from 'components/theme/Button'
import classNames from 'classnames'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import styles from './styles'
import { backButton } from 'actions/template'
import { last } from 'lodash'

export default connect(
  (state) => ({
    value: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    emailCardSelected: last(state.email.cardSelected),
  }),
  (dispatch) => {
    return bindActionCreators(
      {
        backButton,
      },
      dispatch,
    )
  },
)(
  withStyles(styles)(({ classes, backButton, size, text }) => {
    const button = (sizeParam) => (
      <Button
        variant="outlined"
        // className={classes.button}
        color="secondary"
        size={sizeParam}
        onClick={backButton}
      >
        <KeyboardArrowLeftIcon
          className={classNames(classes.leftIcon, classes.iconSmall)}
        />
        {text}
      </Button>
    )

    return size ? (
      button(size)
    ) : (
      <Fragment>
        <Hidden smDown>{button('medium')}</Hidden>
        <Hidden mdUp>{button('small')}</Hidden>
      </Fragment>
    )
  }),
)
